<template>

  <div class="dashboard-container">

    <ProjectManager v-if="projectManagerRole" :companyUID="user_company" :readonlyMode="true" />
    <CompanyManager v-if="companyManagerRole" :readonlyMode="true" /> 
  </div>
  
</template>

<script>
import { mapGetters } from "vuex";
import { getCompanyBy } from "@/api/company";
import CompanyManager from "@/views/company/components/company-manager";
import ProjectManager from "@/views/project/components/project-manager";

export default {
  components: {
    ProjectManager,
    CompanyManager,

  },
  computed: {
    ...mapGetters(['user_company']),
    projectManagerRole(){
      return this.roleAuth([this.role.admin, this.role.user])
    },
    companyManagerRole(){
      return this.roleAuth([this.role.spadmin])
    }
  },
  created(){
    if(this.projectManagerRole){
      getCompanyBy(this.user_company).then(async ({ result, data }) => {
        if (result) {
          await this.$store.dispatch('user/setCompany', data)
        }
      });
    }

  }
};
</script>

<style lang="scss">

</style>